import vendingMachine from './assets/vendingMachine.webp';
import { GPTGameIcon } from './types';

export const VendingMachineIcon: GPTGameIcon = ({ width = 24, height = 24, className }) => {
  return (
    <img
      src={vendingMachine}
      width={width}
      height={height}
      className={className}
      alt="Vending Machine game icon"
    />
  );
};
